(function embedSrcAttrDirectiveDefinition() {
    'use strict';

    angular.module('EmbedSrcAttr', [])
        .directive('embedSrc', function() {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    embedSrc: '@'
                },
                template: '<embed src="{{content}}" />',
                link: function(scope, element, attrs) {
                    var current = element;
                    scope.$watch('embedSrc', function (value) {

                        var clone = element
                            .clone()
                            .attr('src', value);
                        current.replaceWith(clone);
                        current = clone;
                    });
                }
            };
        })
        .directive('objectData', function () {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    objectData: '@'
                },
                link: function (scope, element, attrs) {
                    var current = element;

                    scope.$watch('objectData', function (value) {
                        element.attr('data', value);
                    });
                }
            };
        });
})();